var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-t-10"},[_c('div',{staticClass:"border-all bg-search p-tb-10 p-lr-10"},[_vm._t("title")],2),_c('div',{staticClass:"bg-white p-tb-10 p-lr-10"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }